import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, interval } from 'rxjs';
import { AppSettings, SettingsService } from '../../services';

@Component({
  selector: 'app-two-factor-auth',
  templateUrl: './two-factor-auth.component.html',
  styleUrls: ['./two-factor-auth.component.scss']
})
export class TwoFactorAuthenticationComponent implements OnInit, OnDestroy {
  form: FormGroup;
  email: string;
  isLoading = false;
  errorMessage = '';
  resendCountdown = 30;
  canResend = false;
  isInitialState = true;  // Track initial state
  countdownSubscription: Subscription;
  logoTitle:string;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private settings: SettingsService,
    private appSettings: AppSettings,
  ) {
    this.form = this.fb.group({
      verificationCode: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]]
    });
    this.logoTitle = appSettings.logoTitle;
  }

  ngOnInit(): void {
    this.email = this.route.snapshot.queryParamMap.get('email') || '';
    if (!this.email) {
      this.router.navigate(['/signin']);
    }
  }

  sendInitialCode() {
    this.isInitialState = false;
    this.isLoading = true;
    
    this.authService.sendTwoFactorAuthenticationCode(this.email).subscribe(
      () => {
        this.startResendCountdown();
        this.isLoading = false;
      },
      (error) => {
        this.errorMessage = this.translate.instant('2FA.RESEND_ERROR');
        this.isLoading = false;
      }
    );
  }

  resendCode() {
    this.isLoading = true;
    this.errorMessage = '';
    
    this.authService.sendTwoFactorAuthenticationCode(this.email).subscribe(
      () => {
        this.startResendCountdown();
        this.isLoading = false;
      },
      (error) => {
        this.errorMessage = this.translate.instant('2FA.RESEND_ERROR');
        this.isLoading = false;
      }
    );
  }

  startResendCountdown() {
    this.canResend = false;
    this.resendCountdown = 30;
    
    // Clear any existing subscription
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
    }
    
    this.countdownSubscription = interval(1000).subscribe(() => {
      this.resendCountdown--;
      if (this.resendCountdown <= 0) {
        this.canResend = true;
        this.countdownSubscription.unsubscribe();
      }
    });
  }

  onSubmit() {
    if (this.form.invalid || this.isLoading) return;
    
    this.isLoading = true;
    this.errorMessage = '';
    
    const code = this.form.get('verificationCode')?.value;
    
    this.authService.verifyTwoFactorAuthenticationCode(this.email, code).subscribe(
      (success) => {
        if (success) {
          this.router.navigate([this.authService.redirectURL || '/bikes']);
        } else {
          this.errorMessage = this.translate.instant('2FA.INVALID_VERIFICATION_CODE');
        }
        this.isLoading = false;
      },
      (error) => {
        this.errorMessage = this.translate.instant('2FA.VERIFICATION_ERROR');
        this.isLoading = false;
      }
    );
  }

  downloadTermsAndConditions() {
    let selectedLanguage = this.settings.getSelectedLanguage() != null ? this.settings.getSelectedLanguage() : 'en';
    // let languageCode = LanguageExtension.GetLanguageCode(selectedLanguage);
    // this.resourceURL = this.importExportService.downloadTermsAndConditions(languageCode);
    // window.open(this.resourceURL, '_self');
    if (selectedLanguage == 'en') {
      this.router.navigate(['/info/terms-en'])
    } else {
      this.router.navigate(['/info/terms-no']);
    }

  }

  ngOnDestroy() {
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
    }
  }
}